import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import React from "react";
import ContactForm from "../component/contact/ContactForm";

const contactItems = [
  {
    icon: <PhoneIcon sx={{ fontSize: 22 }} />,
    label: "Phone",
    lines: ["+91-9458-693-639", "+91-8700-007-517", "+91-8076-721-629"],
    href: null,
  },
  {
    icon: <EmailIcon sx={{ fontSize: 22 }} />,
    label: "Email",
    lines: ["info@myschoolling.com"],
    href: "mailto:info@myschoolling.com",
  },
  {
    icon: <LocationOnIcon sx={{ fontSize: 22 }} />,
    label: "Address",
    lines: [
      "Versynix Global Pvt. Ltd.",
      "93/295/21, RDA Colony, Indira Nagar,",
      "Raebareli, UP – 229001, India",
    ],
    href: null,
  },
];

const socialLinks = [
  { icon: <XIcon />, url: "https://x.com/MSchoollin95170", label: "Twitter" },
  { icon: <FacebookIcon />, url: "https://www.facebook.com/profile.php?id=61576745007909", label: "Facebook" },
  { icon: <LinkedInIcon />, url: "https://myschoolling.com", label: "LinkedIn" },
];

const ContactUs = () => {
  return (
    <Box>
      {/* ===== HERO ===== */}
      <Box
        sx={{
          pt: { xs: 10, md: 14 },
          pb: { xs: 8, md: 12 },
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(160deg, #F8FAFF 0%, #EEF2FF 60%, #F0F7FF 100%)",
        }}
      >
        <Box sx={{ position:"absolute", top:-120, right:-120, width:500, height:500, borderRadius:"50%", background:"radial-gradient(circle,rgba(79,110,247,0.1) 0%,transparent 70%)", pointerEvents:"none" }} />

        <Container maxWidth="md" sx={{ textAlign: "center", position: "relative", zIndex: 1 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.8,
              borderRadius: "100px",
              bgcolor: "rgba(79,110,247,0.08)",
              border: "1px solid rgba(79,110,247,0.2)",
              mb: 3,
            }}
          >
            <Typography fontSize="0.82rem" fontWeight={600} color="#4F6EF7" letterSpacing="0.04em">
              CONTACT US
            </Typography>
          </Box>

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.2rem", md: "3.4rem" },
              fontWeight: 900,
              color: "#0D1B4B",
              mb: 2.5,
            }}
          >
            Let's Start a{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg, #4F6EF7 0%, #7C3AED 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Conversation
            </Box>
          </Typography>

          <Typography
            variant="h6"
            color="#64748B"
            sx={{ maxWidth: 600, mx: "auto", lineHeight: 1.8, fontWeight: 400 }}
          >
            We're here to help. Whether you're a school looking for a demo or
            a parent needing support — reach out and we'll respond promptly.
          </Typography>
        </Container>
      </Box>

      {/* ===== CONTENT ===== */}
      <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: "#fff" }} id="contact_us">
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 6, md: 5 }} alignItems="stretch">
            {/* LEFT: Contact info panel */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  height: "100%",
                  p: { xs: 4, md: 5 },
                  borderRadius: "24px",
                  background: "linear-gradient(160deg, #0D1B4B 0%, #1A2F6E 100%)",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Decorative orbs */}
                <Box sx={{ position:"absolute", top:-60, right:-60, width:200, height:200, borderRadius:"50%", background:"rgba(79,110,247,0.2)", pointerEvents:"none" }} />
                <Box sx={{ position:"absolute", bottom:-40, left:-40, width:140, height:140, borderRadius:"50%", background:"rgba(255,255,255,0.04)", pointerEvents:"none" }} />

                <Box sx={{ position: "relative", zIndex: 1, flex: 1 }}>
                  <Typography fontWeight={800} fontSize="1.4rem" mb={1}>
                    Contact Information
                  </Typography>
                  <Typography sx={{ color: "rgba(255,255,255,0.6)", mb: 5, lineHeight: 1.7, fontSize: "0.9rem" }}>
                    Fill out the form and our team will get back to you within 24 hours.
                  </Typography>

                  {/* Contact items */}
                  {contactItems.map((item, i) => (
                    <Box key={i} display="flex" gap={2.5} mb={4} alignItems="flex-start">
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "12px",
                          bgcolor: "rgba(255,255,255,0.1)",
                          border: "1px solid rgba(255,255,255,0.12)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          color: "#a5b4fc",
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography fontSize="0.75rem" fontWeight={600} sx={{ color: "rgba(255,255,255,0.45)", mb: 0.5, letterSpacing: "0.06em", textTransform: "uppercase" }}>
                          {item.label}
                        </Typography>
                        {item.lines.map((line, j) => (
                          <Typography
                            key={j}
                            component={item.href && j === 0 ? "a" : "span"}
                            href={item.href || undefined}
                            display="block"
                            fontSize="0.9rem"
                            fontWeight={500}
                            sx={{
                              color: item.href ? "#a5b4fc" : "#e2e8f0",
                              lineHeight: 1.65,
                              textDecoration: "none",
                              "&:hover": item.href ? { color: "#fff" } : {},
                            }}
                          >
                            {line}
                          </Typography>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </Box>

                {/* Social links */}
                <Box sx={{ position: "relative", zIndex: 1, pt: 3, borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                  <Typography fontSize="0.78rem" fontWeight={600} sx={{ color: "rgba(255,255,255,0.4)", mb: 1.5, letterSpacing: "0.06em", textTransform: "uppercase" }}>
                    Follow Us
                  </Typography>
                  <Box display="flex" gap={1}>
                    {socialLinks.map((s) => (
                      <IconButton
                        key={s.label}
                        component="a"
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={s.label}
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: "10px",
                          bgcolor: "rgba(255,255,255,0.08)",
                          color: "#94a3b8",
                          border: "1px solid rgba(255,255,255,0.08)",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            bgcolor: "rgba(79,110,247,0.3)",
                            color: "#fff",
                            transform: "translateY(-2px)",
                            borderColor: "rgba(79,110,247,0.4)",
                          },
                        }}
                      >
                        {s.icon}
                      </IconButton>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* RIGHT: Form */}
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  p: { xs: 4, md: 6 },
                  borderRadius: "24px",
                  border: "1.5px solid rgba(13,27,75,0.07)",
                  bgcolor: "#F8FAFF",
                  height: "100%",
                }}
              >
                <ContactForm />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default ContactUs;
